import React from "react";
import styles from "./render-svg-based-on-type.module.scss";
import classnames from "classnames";
import { QUERY_RESPONSE_PERSON_TYPES } from "@whatslly/types/Person";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
import lowerCase from "lodash/lowerCase";
import type { TuvisIconNamesType } from "@whatslly/types/UI-V2/BaseElements/Svg/TuvisIconNamesType";
import { Tag, TagProps } from "@whatslly/ui-components/Tag";

export const RenderSvgBasedOnType: React.FC<{ type: string; typeText?: string; size?: "small" | "large"; hideIcon?: boolean; onClick?: () => void }> =
  React.memo(({ type, typeText, size, hideIcon, onClick }) => {
    const currentType = type === QUERY_RESPONSE_PERSON_TYPES.PERSON_ACCOUNT ? "person-account" : (lowerCase(type) as TuvisIconNamesType);
    return ["Contact", "Lead", "Account", "Person Account", "Unknown", "Account", "Group"].includes(type) ? (
      <div
        data-testid={`record-badge-${type}`}
        onClick={onClick}
        className={classnames(
          styles.imageTypeSection,
          { [styles.largeSize]: size === "large" },
          { [styles.typeText]: typeText },
          {
            [styles.lead]: type === QUERY_RESPONSE_PERSON_TYPES.LEAD,
            [styles.contact]: type === QUERY_RESPONSE_PERSON_TYPES.CONTACT,
            [styles.account]: type === QUERY_RESPONSE_PERSON_TYPES.ACCOUNT,
            [styles.personAccount]: type === QUERY_RESPONSE_PERSON_TYPES.PERSON_ACCOUNT || type === QUERY_RESPONSE_PERSON_TYPES.ACCOUNT,
            [styles.unknown]: type === QUERY_RESPONSE_PERSON_TYPES.UNKNOWN,
            [styles.group]: type === "Group",
            [styles.clickAble]: onClick,
          }
        )}
      >
        {!hideIcon && <Svg iconName={currentType} disabled={true} width={size === "large" ? 20 : 12} height={size === "large" ? 20 : 12} />}
        {typeText && (
          <div className={classnames(styles.tagText, { [styles.largeSize]: size === "large", [styles.hideIcon]: hideIcon })}>{typeText}</div>
        )}
      </div>
    ) : (
      <div
        className={classnames(styles.imageTypeSection, styles.unknown, { [styles.largeSize]: size === "large" }, { [styles.typeText]: typeText })}
        data-testid={`record-badge-Unknown`}
      >
        {!hideIcon && <Svg iconName="unknown" disabled={true} width={size === "large" ? 20 : 12} height={size === "large" ? 20 : 12} />}
        {typeText && <div className={classnames(styles.tagText, { [styles.largeSize]: size === "large" })}>{typeText}</div>}
      </div>
    );
  });
